import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import styles from "./paragraph-slide.css";

import type { SlideState } from "../../types.d";
import type { SlideViewMode } from "../slide/slide";

@customElement("bp-paragraph-slide")
export class ParagraphSlide extends LitElement {
  static styles = styles;

  @property({ attribute: "caption" })
  caption?: string;

  @property({ attribute: "content" })
  content?: string;

  @property()
  slideState?: SlideState;

  @property({ attribute: "title" })
  slideTitle?: string;

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  render() {
    return html`
      <bp-scrollable-slide
        view-mode="${this.viewMode}"
        .slideState=${this.slideState}
      >
        <div slot="title">${unsafeHTML(this.slideTitle)}</div>
        <div slot="content">
          ${unsafeHTML(this.content)}
          ${this.caption
            ? html`<div class="caption">${unsafeHTML(this.caption)}</div>`
            : ""}
        </div>
      </bp-scrollable-slide>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-paragraph-slide": ParagraphSlide;
  }
}
